/* global restVar */
import { useState, useEffect, useCallback, useRef } from '@wordpress/element';
import QRScanner from 'qr-scanner';
export default function Scanner( {
	setIsScanning,
	getBonoFromServer,
	videoRef,
} ) {
	const justScannedRef = useRef( [] );
	const qrScannerRef = useRef( null );
	const [ error, setError ] = useState( '' );

	const handleScan = useCallback(
		( result ) => {
			if (
				qrScannerRef.current &&
				! justScannedRef.current.includes( result.data )
			) {
				justScannedRef.current = [
					...justScannedRef.current,
					result.data,
				];
				qrScannerRef.current.stop();

				let bonoUrl;
				try {
					bonoUrl = new URL( result.data );
				} catch ( e ) {
					qrScannerRef.current.start();
					setError( 'Código QR inválido' );
					return;
				}

				const restUrl = new URL( restVar.sciBonosComercioEndpoint );

				if ( bonoUrl.hostname !== restUrl.hostname ) {
					qrScannerRef.current.start();
					setError( 'Código QR inválido' );
					return;
				}

				const bonoCode = bonoUrl.searchParams.get( 'c' );

				if (
					! bonoCode ||
					bonoCode.length !== 10 ||
					! /^[a-zA-Z0-9]{10}$/.test( bonoCode )
				) {
					qrScannerRef.current.start();
					setError( 'Código QR inválido' );
					return;
				}

				setIsScanning( false );
				getBonoFromServer( bonoCode );
			}
		},
		[ setIsScanning, getBonoFromServer ]
	);

	useEffect( () => {
		if ( ! videoRef.current ) return;

		const scanner = new QRScanner(
			videoRef.current,
			( result ) => handleScan( result ),
			{
				highlightScanRegion: true,
				highlightCodeOutline: true,
				maxScansPerSecond: 25,
			}
		);

		scanner.start();
		qrScannerRef.current = scanner;

		return () => {
			scanner.destroy();
		};
	}, [ handleScan, videoRef ] );

	return <div className="sci-bcl-bonos__error">{ error }</div>;
}
